<template>
  <nav
    class="navbar navbar-expand-md fixed-top"
    style="
      background-color: #fff !important;
      border-bottom: 1px solid #e8e8e8;
      width: 100% !important;
      display: flex;
      justify-content: space-between;
      max-width: 1440px;
      margin: auto !important;
    "
  >
    <div style="display: flex; width: 280px">
      <!-- <button
        class="btn p-0 menuButtonRes"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <i class="bi bi-three-dots-vertical" style="font-size: 22px"></i>
      </button> -->
      <a href="/">
        <img src="/assets/logo/t4.png?" style="height: 49px" alt="" />
        <label class="mx-4" style="color: #000">
          <!--
          {{ $t("app_name") }}  
        -->
        </label>
      </a>
      <div
        v-if="userAgent.screenType === 'small'"
        class="input-group input-group-merge input-group-borderless input-group-hover-light navbar-input-group"
        style="
          border: 1px solid rgb(232, 232, 232);
          width: calc(100% - 160px);
          position: fixed;
          right: 150px;
        "
      >
        <div class="input-group-prepend input-group-text">
          <i class="bi-search"></i>
        </div>

        <input
          type="search"
          class="js-form-search form-control"
          placeholder="جست و جو"
          v-model="value"
        />
      </div>
    </div>
    <div class="menuList">
      <ul class="navbar-nav mr-auto" style="padding: unset">
        <!--
        <li class="nav-item">
          <router-link
            :to="{ name: 'PanelUser-Agahi-New' }"
            class="nav-link text-dark"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("ثبت آگهی") }}
          </router-link>
        </li>
        -->
        <li class="nav-item">
          <div class="dropdown ms-2">
            <!-- Input Group -->
            <div class="d-none d-lg-block">
              <div
                class="input-group input-group-merge input-group-borderless input-group-hover-light navbar-input-group"
                style="border: 1px solid rgb(232, 232, 232)"
              >
                <div class="input-group-prepend input-group-text">
                  <i class="bi-search"></i>
                </div>

                <input
                  type="search"
                  class="js-form-search form-control"
                  placeholder="جست و جو"
                  v-model="value"
                />
              </div>
            </div>

            <!-- End Input Group -->
          </div>
        </li>

        <!-- <li class="nav-item">
          <router-link :to="{ name: 'PublicAbout' }" class="nav-link text-dark">
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("about_us") }}
          </router-link>
        </li>

        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicContactUs' }"
            class="nav-link text-dark"
          >
            <i class="bi bi-caret-left-fill mx-1"></i>
            {{ $t("contact_us") }}
          </router-link>
        </li> -->
      </ul>
      <a
        href="/user/"
        class="btn btn-sm btn-dark"
        style="display: flex; height: 38px; margin: auto"
      >
        <span style="margin: auto">
          {{ $t("ثبت آگهی") }}
        </span>
      </a>
    </div>
  </nav>
</template>


<script>
export default {
  data() {
    return {
      userAgent: {},
    };
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.userAgent = this.$root.getUserAgentDetails();
    },
  },

  mounted() {
    this.handleResize();
  },
};
</script>


<style scoped>
.menuButtonRes {
  display: none;
}
.menuList {
  display: flex;
  flex-grow: 1;
}
.nav-link:hover {
  color: #a62626 !important;
}

@media (max-width: 1200px) {
  .menuButtonRes {
    display: block;
  }
  .menuList {
    display: none;
  }
  .nav-res {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
  }
}
</style>